import { render, staticRenderFns } from "./FCCRefereePenalities.vue?vue&type=template&id=4db3fded"
import script from "./FCCRefereePenalities.vue?vue&type=script&lang=js"
export * from "./FCCRefereePenalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports